import React from 'react';
import CopyableValue from './CopyableValue';

const countries = ['Scotland', 'England', 'Northern Ireland', 'Ireland', 'Wales', 'UK', 'United Kingdom', 'GB', 'Great Britain'];

const Address = ({ address, area, distance, limit, empty = null, copyable = false }) => {
    if (copyable) {
        return <CopyableAddress address={address} area={area} distance={distance} empty={empty} />;
    }

    return <span>
        {addressFormatter(address, limit, empty)}
        {area && <br />}
        {area && <span className="text-muted">{area.areaName} {distance && <>, {distance.miles} miles</>}</span>}
    </span>
};

const CopyableAddress = ({ address, area, distance, empty = null }) => {
    if (!address) {
        return empty;
    }

    const addressLines = [];

    const property = [address.flatNumber, address.streetNumber].filter(v => !!v).join(' ');
    if (property) {
        addressLines.push({ label: 'Property', value: property });
    }

    if (address.streetName) {
        addressLines.push({ label: 'Street', value: address.streetName });
    }

    if (address.town) {
        addressLines.push({ label: 'Town', value: address.town });
    }

    if (address.postcode) {
        addressLines.push({ label: 'Postcode', value: address.postcode });
    }

    if (address.country && !countries.includes(address.country)) {
        addressLines.push({ label: 'Country', value: address.country });
    }

    if (addressLines.length === 0) {
        return empty;
    }

    return (
        <div className="space-y-2">
            {addressLines.map((line, index) => (
                <CopyableValue
                    key={index}
                    title={null}
                    value={line.value}
                    flush
                />
            ))}
            {area && (
                <div className="text-muted text-sm mt-2">
                    {area.areaName}
                    {distance && <>, {distance.miles} miles</>}
                </div>
            )}
        </div>
    );
};

const addressFormatter = (address, limit, empty = null) => {
    if (!address) {
        return empty;
    }

    const _limit = limit || 9;

    const filtered = {
        property: [address.flatNumber, address.streetNumber].filter(v => !!v).join(' ') ?? null,
        streetName: address.streetName ?? null,
        postcode: address.postcode ?? null,
        town: address.town ?? null,
        country: address.country ?? null,
    };

    if (Object.values(filtered).every(v => !v)) {
        return empty;
    }

    return Object.values(filtered)
        .filter(v => !!v && countries.indexOf(v) === -1)
        .filter(v => v !== true)
        .filter(v => typeof v !== 'object')
        .filter((v, i) => i < _limit)
        .join(', ')
        .replace(/,/, '');
}

export default Address;

export {
    addressFormatter
}
